//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Get User List.
 * @param name (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getUserList(name?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfUserListItemDto> {
    let url_ = getBaseUrl() + "/api/users?";
    if (name === null)
        throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined)
        url_ += "Name=" + encodeURIComponent("" + name) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetUserList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetUserList?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetUserList(_response);
    });
}

function processGetUserList(response: AxiosResponse): Promise<Types.PagedResultOfUserListItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPagedResultOfUserListItemDto(resultData200);
        return Promise.resolve<Types.PagedResultOfUserListItemDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfUserListItemDto>(null as any);
}

/**
 * Column A for User Name,
Column B for Customer Number,
Column C for RealName,
Column D for Email,
Column E for Country Code,
Column F for Role.
Data started from second Row.
First Row for column name.
 * @param file (optional) 
 * @param sendEmails (optional) 
 */
export function createUsersFromExcel(file?: Types.FileParameter | null | undefined, sendEmails?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/create-from-file";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("File", file.data, file.fileName ? file.fileName : "File");
    if (sendEmails === null || sendEmails === undefined)
        throw new Error("The parameter 'sendEmails' cannot be null.");
    else
        content_.append("SendEmails", sendEmails.toString());

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateUsersFromExcel,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateUsersFromExcel?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateUsersFromExcel(_response);
    });
}

function processCreateUsersFromExcel(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Send New Welcome Emails By Role.
 * @param role (optional) 
 */
export function sendNewWelcomeEmailsByRole(role?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/resend-welcome-emails-by-role?";
    if (role === null)
        throw new Error("The parameter 'role' cannot be null.");
    else if (role !== undefined)
        url_ += "role=" + encodeURIComponent("" + role) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendNewWelcomeEmailsByRole,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendNewWelcomeEmailsByRole?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendNewWelcomeEmailsByRole(_response);
    });
}

function processSendNewWelcomeEmailsByRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Send New Welcome Email With New Password.
 * @param emailOrLogin (optional) 
 */
export function sendNewWelcomeEmailWithNewPassword(emailOrLogin?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/resend-welcome-email?";
    if (emailOrLogin === null)
        throw new Error("The parameter 'emailOrLogin' cannot be null.");
    else if (emailOrLogin !== undefined)
        url_ += "EmailOrLogin=" + encodeURIComponent("" + emailOrLogin) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendNewWelcomeEmailWithNewPassword,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendNewWelcomeEmailWithNewPassword?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendNewWelcomeEmailWithNewPassword(_response);
    });
}

function processSendNewWelcomeEmailWithNewPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Create New User.
 */
export function createNewUser(request: Types.CreateNewUserRequestDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/create";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateNewUserRequestDto(request);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateNewUser,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateNewUser?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateNewUser(_response);
    });
}

function processCreateNewUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Get Current User Info.
 */
export function getCurrentUserInfo(config?: AxiosRequestConfig | undefined): Promise<Types.UserEnumRolesDto> {
    let url_ = getBaseUrl() + "/api/users/me";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCurrentUserInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCurrentUserInfo?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCurrentUserInfo(_response);
    });
}

function processGetCurrentUserInfo(response: AxiosResponse): Promise<Types.UserEnumRolesDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initUserEnumRolesDto(resultData200);
        return Promise.resolve<Types.UserEnumRolesDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.UserEnumRolesDto>(null as any);
}

/**
 * Update Current User Info.
 */
export function updateCurrentUserInfo(dto: Types.UpdateCurrentUserInfoDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/me";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateCurrentUserInfoDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateCurrentUserInfo,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigUpdateCurrentUserInfo?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateCurrentUserInfo(_response);
    });
}

function processUpdateCurrentUserInfo(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Update User Information.
 */
export function updateUserInformation(userId: string, dto: Types.UpdateUserDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateUserDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateUserInformation,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigUpdateUserInformation?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateUserInformation(_response);
    });
}

function processUpdateUserInformation(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Deletes user.
 */
export function deleteUser(userId: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/{userId}";
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteUser,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteUser?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteUser(_response);
    });
}

function processDeleteUser(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Changes password.
 */
export function changePassword(dto: Types.ChangePasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/change-password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeChangePasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangePassword,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigChangePassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangePassword(_response);
    });
}

function processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Send Reset Password Email.
 * @param email (optional) 
 */
export function sendResetPasswordEmail(email?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/send-reset-password?";
    if (email === null)
        throw new Error("The parameter 'email' cannot be null.");
    else if (email !== undefined)
        url_ += "email=" + encodeURIComponent("" + email) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendResetPasswordEmail,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendResetPasswordEmail?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendResetPasswordEmail(_response);
    });
}

function processSendResetPasswordEmail(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Resets password.
 * @param username (optional) 
 * @param token (optional) 
 * @param newPassword (optional) 
 */
export function resetPassword(username?: string | undefined, token?: string | undefined, newPassword?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/reset-password?";
    if (username === null)
        throw new Error("The parameter 'username' cannot be null.");
    else if (username !== undefined)
        url_ += "Username=" + encodeURIComponent("" + username) + "&";
    if (token === null)
        throw new Error("The parameter 'token' cannot be null.");
    else if (token !== undefined)
        url_ += "Token=" + encodeURIComponent("" + token) + "&";
    if (newPassword === null)
        throw new Error("The parameter 'newPassword' cannot be null.");
    else if (newPassword !== undefined)
        url_ += "NewPassword=" + encodeURIComponent("" + newPassword) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetPassword,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResetPassword?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetPassword(_response);
    });
}

function processResetPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetUserList: Partial<AxiosRequestConfig> | null;
export function getGetUserListRequestConfig() {
  return _requestConfigGetUserList;
}
export function setGetUserListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetUserList = value;
}
export function patchGetUserListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetUserList = patch(_requestConfigGetUserList ?? {});
}

let _requestConfigCreateUsersFromExcel: Partial<AxiosRequestConfig> | null;
export function getCreateUsersFromExcelRequestConfig() {
  return _requestConfigCreateUsersFromExcel;
}
export function setCreateUsersFromExcelRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateUsersFromExcel = value;
}
export function patchCreateUsersFromExcelRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateUsersFromExcel = patch(_requestConfigCreateUsersFromExcel ?? {});
}

let _requestConfigSendNewWelcomeEmailsByRole: Partial<AxiosRequestConfig> | null;
export function getSendNewWelcomeEmailsByRoleRequestConfig() {
  return _requestConfigSendNewWelcomeEmailsByRole;
}
export function setSendNewWelcomeEmailsByRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendNewWelcomeEmailsByRole = value;
}
export function patchSendNewWelcomeEmailsByRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendNewWelcomeEmailsByRole = patch(_requestConfigSendNewWelcomeEmailsByRole ?? {});
}

let _requestConfigSendNewWelcomeEmailWithNewPassword: Partial<AxiosRequestConfig> | null;
export function getSendNewWelcomeEmailWithNewPasswordRequestConfig() {
  return _requestConfigSendNewWelcomeEmailWithNewPassword;
}
export function setSendNewWelcomeEmailWithNewPasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendNewWelcomeEmailWithNewPassword = value;
}
export function patchSendNewWelcomeEmailWithNewPasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendNewWelcomeEmailWithNewPassword = patch(_requestConfigSendNewWelcomeEmailWithNewPassword ?? {});
}

let _requestConfigCreateNewUser: Partial<AxiosRequestConfig> | null;
export function getCreateNewUserRequestConfig() {
  return _requestConfigCreateNewUser;
}
export function setCreateNewUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateNewUser = value;
}
export function patchCreateNewUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateNewUser = patch(_requestConfigCreateNewUser ?? {});
}

let _requestConfigGetCurrentUserInfo: Partial<AxiosRequestConfig> | null;
export function getGetCurrentUserInfoRequestConfig() {
  return _requestConfigGetCurrentUserInfo;
}
export function setGetCurrentUserInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCurrentUserInfo = value;
}
export function patchGetCurrentUserInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCurrentUserInfo = patch(_requestConfigGetCurrentUserInfo ?? {});
}

let _requestConfigUpdateCurrentUserInfo: Partial<AxiosRequestConfig> | null;
export function getUpdateCurrentUserInfoRequestConfig() {
  return _requestConfigUpdateCurrentUserInfo;
}
export function setUpdateCurrentUserInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateCurrentUserInfo = value;
}
export function patchUpdateCurrentUserInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateCurrentUserInfo = patch(_requestConfigUpdateCurrentUserInfo ?? {});
}

let _requestConfigUpdateUserInformation: Partial<AxiosRequestConfig> | null;
export function getUpdateUserInformationRequestConfig() {
  return _requestConfigUpdateUserInformation;
}
export function setUpdateUserInformationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateUserInformation = value;
}
export function patchUpdateUserInformationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateUserInformation = patch(_requestConfigUpdateUserInformation ?? {});
}

let _requestConfigDeleteUser: Partial<AxiosRequestConfig> | null;
export function getDeleteUserRequestConfig() {
  return _requestConfigDeleteUser;
}
export function setDeleteUserRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteUser = value;
}
export function patchDeleteUserRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteUser = patch(_requestConfigDeleteUser ?? {});
}

let _requestConfigChangePassword: Partial<AxiosRequestConfig> | null;
export function getChangePasswordRequestConfig() {
  return _requestConfigChangePassword;
}
export function setChangePasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangePassword = value;
}
export function patchChangePasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangePassword = patch(_requestConfigChangePassword ?? {});
}

let _requestConfigSendResetPasswordEmail: Partial<AxiosRequestConfig> | null;
export function getSendResetPasswordEmailRequestConfig() {
  return _requestConfigSendResetPasswordEmail;
}
export function setSendResetPasswordEmailRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendResetPasswordEmail = value;
}
export function patchSendResetPasswordEmailRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendResetPasswordEmail = patch(_requestConfigSendResetPasswordEmail ?? {});
}

let _requestConfigResetPassword: Partial<AxiosRequestConfig> | null;
export function getResetPasswordRequestConfig() {
  return _requestConfigResetPassword;
}
export function setResetPasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = value;
}
export function patchResetPasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = patch(_requestConfigResetPassword ?? {});
}